import { render, staticRenderFns } from "./reliableRegister.vue?vue&type=template&id=35d77a00&scoped=true"
import script from "./reliableRegister.vue?vue&type=script&lang=js"
export * from "./reliableRegister.vue?vue&type=script&lang=js"
import style0 from "./reliableRegister.vue?vue&type=style&index=0&id=35d77a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d77a00",
  null
  
)

export default component.exports